import { onMounted, watch, nextTick } from "vue";
import { useRoute } from "vue-router";
import { useCleanQueryParams } from "@/shared/utils/router/useCleanQueryParams";
import { makeLogger } from "@/shared/consola";

const logger = makeLogger("useFocusOnEditSection");

const findFieldToFocus = (field: Element) => {
    const focusable =
        field.querySelector("input") ||
        field.querySelector("textarea") ||
        field.querySelector("[contenteditable]");

    return focusable as HTMLElement;
};

export function useFocusOnEditSection() {
    const route = useRoute();
    const { cleanQueryParams } = useCleanQueryParams();

    function focusOnEditSection() {
        const { query } = route;

        if (query.field) {
            const field = document.querySelector(`[data-field="${query.field}"]`);
            if (!field) {
                logger.warn("Field not found", query.field);
                return;
            }

            const fieldToFocus = findFieldToFocus(field);

            logger.info("fieldToFocus", fieldToFocus);

            if (fieldToFocus) {
                fieldToFocus.focus();
                cleanQueryParams(["field"]);
            } else {
                /* 
                TODO BF: Improve in the future beacuse now it is a bit cumbersome, but it works
                - clicking on the first child of the field (it's open CardToggleAlt card where editabled fields are in)
                */
                (field.children?.[0] as HTMLElement)?.click();

                field.scrollIntoView({ behavior: "smooth" });
                nextTick(() => {
                    const fieldToFocus = findFieldToFocus(field);
                    if (fieldToFocus) {
                        fieldToFocus.focus();
                    }
                    cleanQueryParams(["field"]);
                });
            }
        }
    }

    onMounted(() => {
        watch(
            () => route.fullPath,
            () => {
                if (route.query.field) {
                    focusOnEditSection();
                }
            },
            {
                immediate: true,
            }
        );
    });
}
